import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { CertificateFault, createUseCertificateFaultHandlerMap } from '~libs.shared.account';

import { translationKeys } from '../translations';

export const useCertificateFaultHandlerMap = createUseCertificateFaultHandlerMap({
   onAuthenticationRequired: () => dispatchSnackbarNegativeEvent(translationKeys.authenticationRequired),
   onCertificateNoLongerValid: () => dispatchSnackbarNegativeEvent(translationKeys.certificateNoLongerValid),
   onNoValidCertificateFound: () => dispatchSnackbarNegativeEvent(translationKeys.noValidPersonalCertificate),
   onInvalidPrivateKeyFault: () => dispatchSnackbarNegativeEvent(translationKeys.invalidPersonalCertificatePrivateKey),
});

export type { CertificateFault };
